import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store";
import { fetchAllCountries } from "../../../../Redux/location-mangment/slice";
import { Country as APICountry } from "../../../../Redux/location-mangment/types";

const CountryList = ({
  onSelect,
  searchTerm,
  enabled
}: {
  onSelect?: (country: string) => void;
  searchTerm?: string;
  enabled?: boolean;
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const { countries, loading } = useSelector(
    (state: RootState) => state.location,
  );

  useEffect(() => {
    if (countries.length === 0 && !loading) {
      dispatch(fetchAllCountries());
    }
  }, [countries.length, loading, dispatch]);

  // Filter based on search term (frontend filtering)
  const safeSearchTerm = searchTerm || "";
  const filteredCountries = countries
    .filter((country: APICountry) =>
      country.countryName.toLowerCase().includes(safeSearchTerm.toLowerCase()),
    )
    .sort((a: APICountry, b: APICountry) =>
      a.countryName.localeCompare(b.countryName),
    );

  return (
    <>
      <div style={{ maxHeight: "250px", overflowY: "auto" }}>
        {loading ? (
          <div className="text-center p-2 text-sm">Loading...</div>
        ) : filteredCountries.length > 0 ? (
          filteredCountries.map((country: APICountry, idx) => (
            <div
              key={country._id || idx}
              className="mt-1 dropdown-item border-radius-md mb-1 p-1 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                if (onSelect) onSelect(country.countryName);
              }}
            >
              <a href="." onClick={(e) => e.preventDefault()}>
                <div className="d-flex justify-content-lg-start align-items-center gap-2">
                  <div>
                    <li className="avatar avatar-smd list-unstyled">
                      <img
                        alt={country.countryName}
                        src={
                          country.countryFlag ||
                          "../../assets/img/countries/default.png"
                        }
                        style={{
                          width: "30px",
                          height: "20px",
                          objectFit: "cover",
                          borderRadius: "2px",
                        }}
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = "../../assets/img/flag.jpg";
                        }}
                      />
                    </li>
                  </div>
                  <div>
                    <div>
                      <b className="text-md fw-normal text-black">
                        {country.countryName}
                      </b>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          ))
        ) : (
          <div className="text-center p-2 text-sm text-muted">
            No countries found.
          </div>
        )}
      </div>
    </>
  );
};

export default CountryList;
